import { useEntityTitleDuplicateValidation } from './useEntityTitleDuplicateValidation'

type UseViewTitleDuplicateValidationProps = {
  defaultValue?: string
}

export const useViewTitleDuplicateValidation = ({
  defaultValue = '',
}: UseViewTitleDuplicateValidationProps = {}) =>
  useEntityTitleDuplicateValidation({ entityType: 'view', defaultValue })
